import { getRequestData } from '@/utils';
import {
  renewCausalPlanBsnl,
} from '@/pages/CasualExtension/services/casualExtension';
import cloneDeep from 'lodash/cloneDeep';

const defaultState = {
  step: 0, // 延长有效期业务的步骤
  searchCustInfo: {}, // 从搜索页面同步过来的用户信息
  serviceType: {}, // 从搜索页面同步过来的服务类型
  subServiceType: {}, // 从搜索页面同步过来的子服务类型
  extensionDays: '', // 当前延长时间
  casualExpOff: 0, // 延长天数
  operationDetails: {}, // 业务详情
};

export default {
  namespace: 'casualExtension',
  state: cloneDeep(defaultState),
  effects: {
    *renewCausalPlanBsnl({ payload }, { call }) {
      const response = yield call(renewCausalPlanBsnl, payload);
      return getRequestData(response, false);
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    clear() {
      return cloneDeep(defaultState);
    },
  },
};
